<template>
    <div class="header">
        <b-container>
            <div class="roof">
                <b-row>
                    <b-col cols="12" class="d-lg-none" v-if="$wdconfig.locations.length && location">
                        <b-button class="open-modal-location p-0 d-flex align-items-center ml-auto" @click="showLocationDialog">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" class="mr-1">
                                <path d="M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035
                                c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719
                                c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z"/>
                            </svg>
                            Você está em: {{ location }}
                        </b-button>
                    </b-col>
                    <b-col cols="12" lg="7" class="d-flex align-items-center">
                        <TopBanner :area="2012"/>
                    </b-col>
                    <b-col md="5" class="d-none d-lg-block py-1">
                        <div class="d-flex flex-column">
                            <b-button class="open-modal-location p-0 d-flex align-items-center ml-auto" @click="showLocationDialog" v-if="$wdconfig.locations.length && location">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" class="mr-1">
                                    <path d="M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035
                                    c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719
                                    c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z"/>
                                </svg>
                                Você está em: {{ location }}
                            </b-button>
                            <div class="d-flex justify-content-end align-items-baseline">
                                <div class="menu-user" v-for="item in menu" :key="item.id">
                                    <a :href="item.href" :target="item.target" v-html="item.name"></a>
                                </div>
                                <div class="menu-user" v-if="$store.getters.isAuth">
                                    <nuxt-link to="/logout">Sair</nuxt-link>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>

<script>
    import TopBanner from "~/components/TopBanner";

    export default {
        components: {
            TopBanner
        },
        data() {
            return {
                location: '',
                menu: []
            }
        },
        mounted() {
            if (this.$wdconfig.locations.length > 1) {
                const origin = window.location.origin
                const currentLocation = this.$wdconfig.locations.find(item => {
                    try {
                        return item.link === '/' ? origin : new URL(item.link, origin).origin
                    } catch {
                        return false
                    }
                })

                this.location = currentLocation?.name || ''
            }
        },
        methods: {
            showLocationDialog() {
                this.$root.$emit('bv::show::modal', 'modal-location')
            }
        },
        async fetch() {
            await this.$axios.$get(`/api/v1/menu/?area=5`).then((res) => {
                this.menu = res.data
            }).catch((e) => {
                console.error(e)
            })
        }
    }
</script>
